// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const VolumeOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="VolumeOffIcon" ref={forwardedRef} {...props}>
      <path d="M6.25 12.962H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.25l4.75-4.5v15.003zM9.5 5.95 6.848 8.462H3.5v3h3.348L9.5 13.976z" />
      <path d="m17.5 13.035-1.94-1.955-2.004 2.02-1.056-1.065 2.004-2.02-1.933-1.95L13.627 7l1.933 1.95 1.87-1.885 1.055 1.065-1.868 1.884 1.94 1.956z" />
    </SvgIcon>
  );
});

/**
 * Use when the volume is turned off or quieter
 * @public
 */
export const VolumeOffIcon = /* @__PURE__ */ Object.assign(
  VolumeOffIconComponent,
  { displayName: 'VolumeOffIcon' },
);
